import { z } from 'zod'

export const ADMINORGUSERSPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminOrgUsersPostResponseSchema = z.unknown()
export type AdminOrgUsersPostResponse = z.infer<typeof adminOrgUsersPostResponseSchema>
